import { FC } from 'react';

import { HStack } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { BlockContainer } from '../styled';
import { WalmartLandingOffersProps } from '../types';
import { useLoyaltyWalmart } from '../use-loyalty-walmart';

import {
  Badges,
  HeaderBkAndWalmart,
  HeaderReadySavings,
  ItemContent,
  LinkRoyalText,
  OfferBadge,
  OfferContainer,
  OfferItem,
  StyledPicture,
  Subtitle,
  Title,
} from './styled';
import { WalmartWeekOffers } from './walmart-week-offers';

export const WalmartLandingOffers: FC<React.PropsWithChildren<WalmartLandingOffersProps>> = ({
  isAlreadyLinked,
}) => {
  const { data, loading } = useLoyaltyWalmart();

  const showSeasonalPromo = useFlag(LaunchDarklyFlag.SHOW_WALMART_SEASONAL_PROMO);

  if (loading) {
    return null;
  }

  const badge = data?.badge?.locale;

  return (
    <BlockContainer>
      {!isAlreadyLinked && (
        <HeaderBkAndWalmart>{t('walmartLandingBkWalmartTogether')}</HeaderBkAndWalmart>
      )}
      <HeaderReadySavings>
        {isAlreadyLinked ? t('walmartLandingItsBetter') : t('walmartLandingReadyForMoreSavings')}
      </HeaderReadySavings>
      <LinkRoyalText>
        {isAlreadyLinked ? t('walmartLandingEnjoyYourExclusive') : t('walmartLandingLinkYourRoyal')}
      </LinkRoyalText>

      {showSeasonalPromo && data?.seasonalPromoConfig && (
        <WalmartWeekOffers {...data.seasonalPromoConfig} walmartBadge={badge} />
      )}

      <OfferContainer>
        <OfferItem>
          <HStack mr="$2">
            <StyledPicture source={require('./25Off.png')} alt={'25 Off'} />
            <ItemContent>
              <Title>{t('walmartLanding25Off')}</Title>
              <Subtitle>{t('walmartLandingDailyOn')}</Subtitle>
              <Badges>
                <Picture
                  image={badge}
                  alt={'Walmart'}
                  objectFitContain
                  lazy={false}
                  height="24px"
                />
                <OfferBadge>{t('walmartLandingForDigital')}</OfferBadge>
              </Badges>
            </ItemContent>
          </HStack>
        </OfferItem>
      </OfferContainer>

      <OfferContainer>
        <OfferItem>
          <HStack mr="$2">
            <StyledPicture source={require('./FreeWhooper.png')} alt="Free Whopper" />
            <ItemContent>
              <Title>{t('walmartLandingFreeWhopper')}</Title>
              <Subtitle>{t('walmartLandingWithPurchase')}</Subtitle>
              <Badges>
                <Picture
                  image={badge}
                  alt={'Walmart'}
                  objectFitContain
                  lazy={false}
                  height="24px"
                />
              </Badges>
            </ItemContent>
          </HStack>
        </OfferItem>
      </OfferContainer>
    </BlockContainer>
  );
};
